import React, { Dispatch, SetStateAction } from "react";
import { IDrAce } from "../interfaces/DrAce";

export interface IDrAceContext {
    content?: IDrAce
    setContent: Dispatch<SetStateAction<undefined | IDrAce>>
}

export const DrAceContext = React.createContext<IDrAceContext>({
    setContent: () => {}
});
